import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const digits = this.extractDigits(this.element.value)
    this.lastValidDigits = this.partialTimeValid(digits) ? digits : ""
    this.element.value = this.formatDigits(this.lastValidDigits)
  }

  normalize() {
    const digits = this.extractDigits(this.element.value)
    if (!this.partialTimeValid(digits)) {
      this.element.value = this.formatDigits(this.lastValidDigits)
      return
    }

    this.lastValidDigits = digits
    this.element.value = this.formatDigits(digits)
  }

  blur() {
    const value = this.element.value.trim()
    if (value === "") return

    const digits = this.extractDigits(value)
    if (digits.length === 3) {
      const paddedDigits = `0${digits}`
      if (!this.fullTimeValid(paddedDigits)) {
        this.element.value = this.formatDigits(this.lastValidDigits)
        return
      }

      this.lastValidDigits = paddedDigits
      this.element.value = this.formatDigits(paddedDigits)
      return
    }

    if (!this.fullTimeValid(digits)) {
      this.element.value = this.formatDigits(this.lastValidDigits)
      return
    }

    this.lastValidDigits = digits
    this.element.value = this.formatDigits(digits)
  }

  extractDigits(value) {
    return value.replace(/\D/g, "").slice(0, 4)
  }

  formatDigits(digits) {
    if (digits.length <= 2) return digits

    return `${digits.slice(0, 2)}:${digits.slice(2)}`
  }

  partialTimeValid(digits) {
    if (digits.length === 0) return true
    if (digits.length === 1) return /[0-2]/.test(digits)
    if (digits.length === 2) return Number.parseInt(digits, 10) <= 23
    if (digits.length === 3) return this.partialTimeValid(digits.slice(0, 2)) && Number.parseInt(digits[2], 10) <= 5
    if (digits.length === 4) return this.fullTimeValid(digits)

    return false
  }

  fullTimeValid(digits) {
    if (digits.length !== 4) return false

    const hours = Number.parseInt(digits.slice(0, 2), 10)
    const minutes = Number.parseInt(digits.slice(2, 4), 10)

    return !Number.isNaN(hours) && !Number.isNaN(minutes) && hours <= 23 && minutes <= 59
  }
}
